<div class="shell-search-modal" role="dialog" aria-modal="true">
  <div class="shell-search-modal__header">
    <div class="shell-search-modal__input-wrapper">
      <mat-icon svgIcon="search" class="shell-search-modal__icon"></mat-icon>

      <input
        #searchInput
        class="shell-search-modal__input"
        type="text"
        [formControl]="searchControl"
        placeholder="Search"
        autocomplete="off"
        (keydown)="onInputKeydown($event)"
      />
    </div>

    <ts-button type="stroked" color="accent" (click)="closeDialogAndReset()">esc</ts-button>
  </div>

  <div
    class="shell-search-modal__results"
    role="listbox"
    [attr.aria-activedescendant]="selectedIndex !== null ? 'search-row-' + selectedIndex : null"
  >
    @if (ui().isLoading) {
      <div class="shell-search-modal__loading">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>
    } @else {
      @if (results?.length) {
        @for (group of groupedResults; track trackByGroupType($index, group)) {
          <div class="shell-search-modal__group">
            <div class="shell-search-modal__group-title">{{ group.label }}</div>

            @for (row of group.items; track trackByRowIdx($index, row)) {
              <div
                class="shell-search-modal__result-row"
                [class.shell-search-modal__result-row--active]="row.idx === selectedIndex"
                id="search-row-{{ row.idx }}"
                role="option"
                [attr.aria-selected]="row.idx === selectedIndex"
                (mouseenter)="selectedIndex = row.idx"
                (click)="onResultRowClicked()"
              >
                <app-result-item [item]="row.item" [query]="searchControl.value || ''"></app-result-item>
              </div>
            }
          </div>
        }
      } @else {
        <div class="shell-search-modal__empty">
          @if ((searchControl.value || '').length >= minLength) {
            No results to show
          } @else {
            Type at least {{ minLength }} characters to search
          }
        </div>
      }
    }
  </div>
</div>
